import gql from 'graphql-tag'
import { resourceFragment, resourceTypeFragment } from '@/graphql/resource/resourceFragments'
import { resourceUnavailabilityFragment, resourceUnavailabilityTypeFragment } from '@/graphql/resourceUnavailability/resourceUnavailabilityFragments'
export const UPSERTRESOURCE = gql`
    mutation upsertResource(
        $id: ID
        $name: String!
        $description: String
        $typeID: ID
        $disconnectType: Boolean
        $ignore_tracking: Boolean
        $applyTo: ApplyToModels
        $unavailabilities: [upsertResourceUnavailabilityInput]
        $deleteUnavailabilities: [ID]
    ){
        upsertResource(
            input: {
                id: $id
                name: $name
                description: $description
                type: {
                    connect: $typeID
                    disconnect: $disconnectType
                }
                unavailabilities: {
                    sync: []
                    upsert: $unavailabilities
                    delete: $deleteUnavailabilities
                }
                ignore_tracking: $ignore_tracking
                applyTo: $applyTo
            }
        ){
            ...resourceFragment
            type {
                ...resourceTypeFragment
            }
            unavailabilities{
                ...resourceUnavailabilityFragment
                type{
                    ...resourceUnavailabilityTypeFragment
                }
            }
        }
    }
    ${resourceFragment}
    ${resourceTypeFragment}
    ${resourceUnavailabilityFragment}
    ${resourceUnavailabilityTypeFragment}
`
export const UPSERTRESOURCETYPE = gql`
    mutation upsertResourceType(
        $id: ID
        $name: String!
        $color: String
    ){
        upsertResourceType(
            id: $id
            name: $name
            color: $color
        ){
            ...resourceTypeFragment
        }
    }
    ${resourceTypeFragment}
`
export const RESTORERESOURCE = gql`
    mutation restoreResource(
        $id: ID!
    ){
        restoreResource(
            id: $id
        ){
            ...resourceFragment
            type {
                ...resourceTypeFragment
            }
            unavailabilities{
                ...resourceUnavailabilityFragment
                type{
                    ...resourceUnavailabilityTypeFragment
                }
            }
        }
    }
    ${resourceFragment}
    ${resourceTypeFragment}
    ${resourceUnavailabilityFragment}
    ${resourceUnavailabilityTypeFragment}
`

export const RESTORERESOURCETYPE = gql`
    mutation restoreResourceType(
        $id: ID!
    ){
        restoreResourceType(
            id: $id
        ){
            ...resourceTypeFragment
        }
    }
    ${resourceTypeFragment}
`

export const DELETERESOURCE = gql`
    mutation deleteResource(
        $id: ID!
    ){
        deleteResource(
            id: $id
        ){
            ...resourceFragment
        }
    }
    ${resourceFragment}
`
export const DELETERESOURCETYPE = gql`
    mutation deleteResourceType(
        $id: ID!
    ){
        deleteResourceType(
            id: $id
        ){
            ...resourceTypeFragment
        }
    }
    ${resourceTypeFragment}
`

export const UPDATERESOURCECUSTOMORDER = gql`
    mutation updateResourceCustomOrder(
        $id: ID!
        $index: Int!
    ){
        updateResourceCustomOrder(
            id: $id
            customOrder: $index
        ){
            ...resourceFragment
        }
    }
    ${resourceFragment}
`